export const TYPES = {
	ADD_TO_CART: "ADD_TO_CART",
	ADD_ONE_FROM_CART: "ADD_ONE_FROM_CART",
	REMOVE_ONE_FROM_CART: "REMOVE_ONE_FROM_CART",
	REMOVE_ALL_FROM_CART: "REMOVE_ALL_FROM_CART",
	CLEAR_CART: "CLEAR_CART",
};
